import classNames from 'classnames';
import { RankPosition } from '../../../model/interfaces';
import styles from './rankDelta.module.scss';

export default function RankDelta(props: { start: RankPosition; finish: RankPosition }) {
  if (!props.start) return null;

  if (props.start === props.finish || !props.finish)
    return <div className={classNames(styles.delta, styles.up)}>{props.start}</div>;

  const [start, finish] = [props.start, props.finish].map((v) => Number(/\d+/.exec(v.toString())));
  const delta = start - finish;
  return (
    <div className={classNames(styles.delta, delta >= 0 ? styles.up : styles.down)}>
      <div>{finish}</div>
      <span>
        {delta > 0 && '+'}
        {delta}
      </span>
    </div>
  );
}
